module.exports = __webpack_public_path__ + "static/media/home_slide2.bf895078.jpg";